/**
 * Column labels mapping for Portfolio Backlog
 * Maps database field names to i18n translation keys
 */
export const BACKLOG_INITIATIVE_LABELS: { [key: string]: string } = {
  'pk': 'COLUMNS.BACKLOG.PK',
  'stage': 'COLUMNS.BACKLOG.STAGE',
  'initiativeType': 'COLUMNS.BACKLOG.INITIATIVE_TYPE',
  'taType': 'COLUMNS.BACKLOG.TA_TYPE',
  'budgetType': 'COLUMNS.BACKLOG.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.BACKLOG.CC_AFE',
  'id': 'COLUMNS.BACKLOG.MEJ_ID',
  'description': 'COLUMNS.BACKLOG.DESCRIPTION',
  'areaType': 'COLUMNS.BACKLOG.AREA',
  'mciProgram': 'COLUMNS.BACKLOG.MCI_PROGRAM',
  'year': 'COLUMNS.BACKLOG.YEAR',
  'multiYear': 'COLUMNS.BACKLOG.MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.BACKLOG.PLANNED_START_DATE',
  'plannedEndDate': 'COLUMNS.BACKLOG.PLANNED_END_DATE',
  'needByDate': 'COLUMNS.BACKLOG.NEED_BY_DATE',
  'actualStartDate': 'COLUMNS.BACKLOG.ACTUAL_START_DATE',
  'actualEndDate': 'COLUMNS.BACKLOG.ACTUAL_END_DATE',
  'afeNumber': 'COLUMNS.BACKLOG.AFE_NUMBER',
  'originalBudget': 'COLUMNS.BACKLOG.ORIGINAL_BUDGET_K',
  'revisedBudget': 'COLUMNS.BACKLOG.REVISED_BUDGET_K',
  'revisedOutlook': 'COLUMNS.BACKLOG.REVISED_OUTLOOK_K',
  'fyOutlook': 'COLUMNS.BACKLOG.FY_OUTLOOK_K',
  'isServiceRequest': 'COLUMNS.BACKLOG.IS_SERVICE_REQUEST',
  'actualsYTD': 'COLUMNS.BACKLOG.ACTUALS_YTD_K',
  'opportunityDescription': 'COLUMNS.BACKLOG.OPPORTUNITY_DESCRIPTION',
  'potentialSolution': 'COLUMNS.BACKLOG.POTENTIAL_SOLUTION',
  'riskOrAlternative': 'COLUMNS.BACKLOG.RISK_OR_ALTERNATIVE',
  'riptUrl': 'COLUMNS.BACKLOG.RIPT_URL',
  'abc': 'COLUMNS.BACKLOG.ABC',
  'ript': 'COLUMNS.BACKLOG.RIPT',
  'drivingCriteria': 'COLUMNS.BACKLOG.DRIVING_CRITERIA',
  'riskManRiskScore': 'COLUMNS.BACKLOG.RISK_MANAGEMENT_SCORE',
  'riskManCategory': 'COLUMNS.BACKLOG.RISK_MANAGEMENT_CATEGORY',
  'ror': 'COLUMNS.BACKLOG.ROR',
  'dpi': 'COLUMNS.BACKLOG.DPI',
  'initialInvestment': 'COLUMNS.BACKLOG.INITIAL_INVESTMENT',
  'hseRiskEfficiency': 'COLUMNS.BACKLOG.HSE_RISK_EFFICIENCY',
  'likelyScenario': 'COLUMNS.BACKLOG.LIKELY_SCENARIO',
  'likelyConsequence': 'COLUMNS.BACKLOG.LIKELY_CONSEQUENCE',
  'isCanceled': 'COLUMNS.BACKLOG.IS_CANCELED',
  'comment': 'COLUMNS.BACKLOG.COMMENT',
  'initiativeOwnerSharedEmail': 'COLUMNS.BACKLOG.OWNER',
  'stageStatus': 'COLUMNS.BACKLOG.STAGE_STATUS',
  'actions': 'COLUMNS.BACKLOG.ACTIONS',
  'afeAmount': 'COLUMNS.BACKLOG.AFE_AMOUNT_K',
  'costController': 'COLUMNS.BACKLOG.COST_CONTROLLER',
  'financeStatus': 'COLUMNS.BACKLOG.FINANCE_STATUS',
  'afeStartDate': 'COLUMNS.BACKLOG.AFE_START_DATE',
  'afeEndDate': 'COLUMNS.BACKLOG.AFE_END_DATE',
  'afeComment': 'COLUMNS.BACKLOG.AFE_COMMENTS',
  'areaPriority': 'COLUMNS.BACKLOG.AREA_PRIORITY',
  'tcoPriority': 'COLUMNS.BACKLOG.TCO_PRIORITY',
  'projectProgress': 'COLUMNS.BACKLOG.PROJECT_PROGRESS',
  'createdOn': 'COLUMNS.BACKLOG.CREATED_ON',
  'createdBy': 'COLUMNS.BACKLOG.CREATED_BY',
  'approvedBudget': 'COLUMNS.BACKLOG.APPROVED_BUDGET_K',
  'coordinatorName': 'COLUMNS.BACKLOG.COORDINATOR_NAME',
  'coordinatorEmail': 'COLUMNS.BACKLOG.COORDINATOR_EMAIL',
  'fy1': 'COLUMNS.BACKLOG.FY1',
  'fy2': 'COLUMNS.BACKLOG.FY2',
  'fy3': 'COLUMNS.BACKLOG.FY3',
  'isForecastUpdated': 'COLUMNS.BACKLOG.IS_FORECAST_UPDATED',
  'isForReview': 'COLUMNS.BACKLOG.IS_FOR_REVIEW',
  'initiatorEmail': 'COLUMNS.BACKLOG.INITIATOR_EMAIL',
  'currentFyGrandTotal': 'COLUMNS.BACKLOG.CURRENT_FY_GRAND_TOTAL',
  'lastFyGrandTotal': 'COLUMNS.BACKLOG.LAST_FY_GRAND_TOTAL'
};
/**
 * Amount column labels without the unit suffix, for tables that append
 * the unit themselves based on the K$/$ toggle.
 */
export const BACKLOG_UNITLESS_AMOUNT_LABELS: { [key: string]: string } = {
  'originalBudget': 'COLUMNS.BACKLOG.ORIGINAL_BUDGET',
  'revisedBudget': 'COLUMNS.BACKLOG.REVISED_BUDGET',
  'revisedOutlook': 'COLUMNS.BACKLOG.REVISED_OUTLOOK',
  'fyOutlook': 'COLUMNS.BACKLOG.FY_OUTLOOK',
  'actualsYTD': 'COLUMNS.BACKLOG.ACTUALS_YTD',
  'approvedBudget': 'COLUMNS.BACKLOG.APPROVED_BUDGET'
};
export const FORECAST_LABELS: { [key: string]: string } = {
  'pk': 'COLUMNS.FORECAST.PK',
  'stage': 'COLUMNS.FORECAST.STAGE',
  'initiativeType': 'COLUMNS.FORECAST.INITIATIVE_TYPE',
  'taType': 'COLUMNS.FORECAST.TA_TYPE',
  'budgetType': 'COLUMNS.FORECAST.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.FORECAST.CC_AFE',
  'id': 'COLUMNS.FORECAST.MEJ_ID',
  'description': 'COLUMNS.FORECAST.DESCRIPTION',
  'areaType': 'COLUMNS.FORECAST.AREA',
  'mciProgram': 'COLUMNS.FORECAST.MCI_PROGRAM',
  'year': 'COLUMNS.FORECAST.YEAR',
  'multiYear': 'COLUMNS.FORECAST.MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.FORECAST.PLANNED_START_DATE',
  'plannedEndDate': 'COLUMNS.FORECAST.PLANNED_END_DATE',
  'needByDate': 'COLUMNS.FORECAST.NEED_BY_DATE',
  'actualStartDate': 'COLUMNS.FORECAST.ACTUAL_START_DATE',
  'isServiceRequest': 'COLUMNS.FORECAST.IS_SERVICE_REQUEST',
  'actualEndDate': 'COLUMNS.FORECAST.ACTUAL_END_DATE',
  'afeNumber': 'COLUMNS.FORECAST.AFE_NUMBER',
  'originalBudget': 'COLUMNS.FORECAST.ORIGINAL_BUDGET_K',
  'revisedBudget': 'COLUMNS.FORECAST.REVISED_BUDGET_K',
  'revisedOutlook': 'COLUMNS.FORECAST.REVISED_OUTLOOK_K',
  'fyOutlook': 'COLUMNS.FORECAST.CURRENT_OUTLOOK_K',
  'actualsYTD': 'COLUMNS.FORECAST.ACTUALS_YTD_K',
  'opportunityDescription': 'COLUMNS.FORECAST.OPPORTUNITY_DESCRIPTION',
  'potentialSolution': 'COLUMNS.FORECAST.POTENTIAL_SOLUTION',
  'riskOrAlternative': 'COLUMNS.FORECAST.RISK_OR_ALTERNATIVE',
  'riptUrl': 'COLUMNS.FORECAST.RIPT_URL',
  'abc': 'COLUMNS.FORECAST.ABC',
  'ript': 'COLUMNS.FORECAST.RIPT',
  'drivingCriteria': 'COLUMNS.FORECAST.DRIVING_CRITERIA',
  'riskManRiskScore': 'COLUMNS.FORECAST.RISK_MANAGEMENT_SCORE',
  'riskManCategory': 'COLUMNS.FORECAST.RISK_MANAGEMENT_CATEGORY',
  'ror': 'COLUMNS.FORECAST.ROR',
  'dpi': 'COLUMNS.FORECAST.DPI',
  'initialInvestment': 'COLUMNS.FORECAST.INITIAL_INVESTMENT',
  'hseRiskEfficiency': 'COLUMNS.FORECAST.HSE_RISK_EFFICIENCY',
  'likelyScenario': 'COLUMNS.FORECAST.LIKELY_SCENARIO',
  'likelyConsequence': 'COLUMNS.FORECAST.LIKELY_CONSEQUENCE',
  'isCanceled': 'COLUMNS.FORECAST.IS_CANCELED',
  'comment': 'COLUMNS.FORECAST.COMMENT',
  'initiativeOwnerSharedEmail': 'COLUMNS.FORECAST.OWNER',
  'stageStatus': 'COLUMNS.FORECAST.STAGE_STATUS',
  'actions': 'COLUMNS.FORECAST.ACTIONS',
  'afeAmount': 'COLUMNS.FORECAST.AFE_AMOUNT_K',
  'costController': 'COLUMNS.FORECAST.COST_CONTROLLER',
  'financeStatus': 'COLUMNS.FORECAST.FINANCE_STATUS',
  'afeStartDate': 'COLUMNS.FORECAST.AFE_START_DATE',
  'afeEndDate': 'COLUMNS.FORECAST.AFE_END_DATE',
  'afeComment': 'COLUMNS.FORECAST.AFE_COMMENTS',
  'areaPriority': 'COLUMNS.FORECAST.AREA_PRIORITY',
  'tcoPriority': 'COLUMNS.FORECAST.TCO_PRIORITY',
  'projectProgress': 'COLUMNS.FORECAST.PROJECT_PROGRESS',
  'approvedBudget': 'COLUMNS.FORECAST.APPROVED_BUDGET_K',
  'fy1': 'COLUMNS.FORECAST.FY1',
  'fy2': 'COLUMNS.FORECAST.FY2',
  'fy3': 'COLUMNS.FORECAST.FY3',
  'isForecastUpdated': 'COLUMNS.FORECAST.IS_FORECAST_UPDATED',
  'isForReview': 'COLUMNS.FORECAST.IS_FOR_REVIEW',
  'initiatorEmail': 'COLUMNS.FORECAST.INITIATOR_EMAIL',
};

export const MEJ_CUTLINE_LABELS: { [key: string]: string } = {
  'initiativePk': 'COLUMNS.MEJ_CUTLINE.INITIATIVE_PK',
  'ript': 'COLUMNS.MEJ_CUTLINE.RIPT',
  'fyOutlook': 'COLUMNS.MEJ_CUTLINE.FY_OUTLOOK',
  'stage': 'COLUMNS.MEJ_CUTLINE.STAGE',
  'area': 'COLUMNS.MEJ_CUTLINE.AREA',
  'orderIndex': 'COLUMNS.MEJ_CUTLINE.ORDER_INDEX',
  'sumOfBudget': 'COLUMNS.MEJ_CUTLINE.SUM_OF_BUDGET',
  'isIn': 'COLUMNS.MEJ_CUTLINE.CUTLINE',
  'leftoverAtCut': 'COLUMNS.MEJ_CUTLINE.LEFTOVER_AT_CUT',
  'stageEnum': 'COLUMNS.MEJ_CUTLINE.STAGE_ENUM',
  'initiativeType': 'COLUMNS.MEJ_CUTLINE.INITIATIVE_TYPE',
  'taType': 'COLUMNS.MEJ_CUTLINE.TA_TYPE',
  'budgetType': 'COLUMNS.MEJ_CUTLINE.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.MEJ_CUTLINE.CC_AFE',
  'isServiceRequest': 'COLUMNS.MEJ_CUTLINE.IS_SERVICE_REQUEST',
  'id': 'COLUMNS.MEJ_CUTLINE.MEJ_ID',
  'description': 'COLUMNS.MEJ_CUTLINE.PROJECT_DESCRIPTION',
  'areaType': 'COLUMNS.MEJ_CUTLINE.AREA_TYPE',
  'mciProgram': 'COLUMNS.MEJ_CUTLINE.MCI_PROGRAM',
  'year': 'COLUMNS.MEJ_CUTLINE.YEAR',
  'multiYear': 'COLUMNS.MEJ_CUTLINE.MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.MEJ_CUTLINE.PLANNED_START_DATE',
  'plannedEndDate': 'COLUMNS.MEJ_CUTLINE.PLANNED_END_DATE',
  'needByDate': 'COLUMNS.MEJ_CUTLINE.NEED_BY_DATE',
  'actualStartDate': 'COLUMNS.MEJ_CUTLINE.ACTUAL_START_DATE',
  'actualEndDate': 'COLUMNS.MEJ_CUTLINE.ACTUAL_END_DATE',
  'afeNumber': 'COLUMNS.MEJ_CUTLINE.AFE_NUMBER',
  'originalBudget': 'COLUMNS.MEJ_CUTLINE.ORIGINAL_BUDGET',
  'revisedBudget': 'COLUMNS.MEJ_CUTLINE.REVISED_BUDGET',
  'actualsYTD': 'COLUMNS.MEJ_CUTLINE.ACTUALS_YTD',
  'fy1': 'COLUMNS.MEJ_CUTLINE.FY1',
  'fy2': 'COLUMNS.MEJ_CUTLINE.FY2',
  'fy3': 'COLUMNS.MEJ_CUTLINE.FY3',
  'projectTotalCost': 'COLUMNS.MEJ_CUTLINE.PROJECT_TOTAL_COST',
  'opportunityDescription': 'COLUMNS.MEJ_CUTLINE.OPPORTUNITY_DESCRIPTION',
  'potentialSolution': 'COLUMNS.MEJ_CUTLINE.POTENTIAL_SOLUTION',
  'riskOrAlternative': 'COLUMNS.MEJ_CUTLINE.RISK_OR_ALTERNATIVE',
  'riptUrl': 'COLUMNS.MEJ_CUTLINE.RIPT_URL',
  'abc': 'COLUMNS.MEJ_CUTLINE.ABC',
  'drivingCriteria': 'COLUMNS.MEJ_CUTLINE.DRIVING_CRITERIA',
  'riskManRiskScore': 'COLUMNS.MEJ_CUTLINE.RISK_MANAGEMENT_SCORE',
  'riskManCategory': 'COLUMNS.MEJ_CUTLINE.RISK_MANAGEMENT_CATEGORY',
  'ror': 'COLUMNS.MEJ_CUTLINE.ROR',
  'dpi': 'COLUMNS.MEJ_CUTLINE.DPI',
  'initialInvestment': 'COLUMNS.MEJ_CUTLINE.INITIAL_INVESTMENT',
  'hseRiskEfficiency': 'COLUMNS.MEJ_CUTLINE.HSE_RISK_EFFICIENCY',
  'likelyScenario': 'COLUMNS.MEJ_CUTLINE.LIKELY_SCENARIO',
  'likelyConsequence': 'COLUMNS.MEJ_CUTLINE.LIKELY_CONSEQUENCE',
  'isCanceled': 'COLUMNS.MEJ_CUTLINE.IS_CANCELED',
  'comment': 'COLUMNS.MEJ_CUTLINE.COMMENT',
  'initiativeOwnerSharedEmail': 'COLUMNS.MEJ_CUTLINE.OWNER',
  'stageStatus': 'COLUMNS.MEJ_CUTLINE.STAGE_STATUS',
  'areaPriority': 'COLUMNS.MEJ_CUTLINE.AREA_PRIORITY',
  'tcoPriority': 'COLUMNS.MEJ_CUTLINE.TCO_PRIORITY',
  'financeStatus': 'COLUMNS.MEJ_CUTLINE.FINANCE_STATUS',
  'projectProgress': 'COLUMNS.MEJ_CUTLINE.PROJECT_PROGRESS',
  'createdOn': 'COLUMNS.MEJ_CUTLINE.CREATED_ON',
  'createdBy': 'COLUMNS.MEJ_CUTLINE.CREATED_BY',
  'approvedBudget': 'COLUMNS.MEJ_CUTLINE.APPROVED_BUDGET_K',
  'afeComment': 'COLUMNS.MEJ_CUTLINE.AFE_COMMENTS',
  'costController': 'COLUMNS.MEJ_CUTLINE.COST_CONTROLLER',
  'afeStartDate': 'COLUMNS.MEJ_CUTLINE.AFE_START_DATE',
  'afeEndDate': 'COLUMNS.MEJ_CUTLINE.AFE_END_DATE',
   'teamName': 'COLUMNS.MEJ_CUTLINE.TEAM_NAME',
   'coordinatorName': 'COLUMNS.BACKLOG.COORDINATOR_NAME',
  'coordinatorEmail': 'COLUMNS.BACKLOG.COORDINATOR_EMAIL',
  'isForecastUpdated': 'COLUMNS.MEJ_CUTLINE.IS_FORECAST_UPDATED',
  'isForReview': 'COLUMNS.MEJ_CUTLINE.IS_FOR_REVIEW',
  'initiatorEmail': 'COLUMNS.MEJ_CUTLINE.INITIATOR_EMAIL'
};

export const PLAN_VS_FACT_LABELS: { [key: string]: string } = {
  'fc': 'COLUMNS.PLAN_VS_FACT.FC_K',
  'act': 'COLUMNS.PLAN_VS_FACT.ACT_K',
  'var': 'COLUMNS.PLAN_VS_FACT.VAR_K',
  'accuracy': 'COLUMNS.PLAN_VS_FACT.ACCURACY',
  'pk': 'COLUMNS.PLAN_VS_FACT.PK',
  'stage': 'COLUMNS.PLAN_VS_FACT.STAGE',
  'initiativeType': 'COLUMNS.PLAN_VS_FACT.INITIATIVE_TYPE',
  'taType': 'COLUMNS.PLAN_VS_FACT.TA_TYPE',
  'budgetType': 'COLUMNS.PLAN_VS_FACT.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.PLAN_VS_FACT.CC_AFE',
  'id': 'COLUMNS.PLAN_VS_FACT.MEJ_ID',
  'description': 'COLUMNS.PLAN_VS_FACT.MEJ_DESCRIPTION',
  'areaType': 'COLUMNS.PLAN_VS_FACT.AREA',
  'mciProgram': 'COLUMNS.PLAN_VS_FACT.PROGRAM',
  'year': 'COLUMNS.PLAN_VS_FACT.YEAR',
  'multiYear': 'COLUMNS.PLAN_VS_FACT.MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.PLAN_VS_FACT.PLANNED_START_DATE',
  'isServiceRequest': 'COLUMNS.PLAN_VS_FACT.IS_SERVICE_REQUEST',
  'plannedEndDate': 'COLUMNS.PLAN_VS_FACT.PLANNED_END_DATE',
  'needByDate': 'COLUMNS.PLAN_VS_FACT.NEED_BY_DATE',
  'actualStartDate': 'COLUMNS.PLAN_VS_FACT.ACTUAL_START_DATE',
  'actualEndDate': 'COLUMNS.PLAN_VS_FACT.ACTUAL_END_DATE',
  'afeNumber': 'COLUMNS.PLAN_VS_FACT.AFE',
  'originalBudget': 'COLUMNS.PLAN_VS_FACT.ORIGINAL_BUDGET_K',
  'revisedBudget': 'COLUMNS.PLAN_VS_FACT.REVISED_BUDGET_K',
  'revisedOutlook': 'COLUMNS.PLAN_VS_FACT.REVISED_OUTLOOK_K',
  'fyOutlook': 'COLUMNS.PLAN_VS_FACT.CURRENT_OUTLOOK_K',
  'actualsYTD': 'COLUMNS.PLAN_VS_FACT.ACTUALS_YTD_K',
  'opportunityDescription': 'COLUMNS.PLAN_VS_FACT.OPPORTUNITY_DESCRIPTION',
  'potentialSolution': 'COLUMNS.PLAN_VS_FACT.POTENTIAL_SOLUTION',
  'riskOrAlternative': 'COLUMNS.PLAN_VS_FACT.RISK_OR_ALTERNATIVE',
  'riptUrl': 'COLUMNS.PLAN_VS_FACT.RIPT_URL',
  'abc': 'COLUMNS.PLAN_VS_FACT.ABC',
  'ript': 'COLUMNS.PLAN_VS_FACT.RIPT',
  'drivingCriteria': 'COLUMNS.PLAN_VS_FACT.DRIVING_CRITERIA',
  'riskManRiskScore': 'COLUMNS.PLAN_VS_FACT.RISK_MANAGEMENT_SCORE',
  'riskManCategory': 'COLUMNS.PLAN_VS_FACT.RISK_MANAGEMENT_CATEGORY',
  'ror': 'COLUMNS.PLAN_VS_FACT.ROR',
  'dpi': 'COLUMNS.PLAN_VS_FACT.DPI',
  'initialInvestment': 'COLUMNS.PLAN_VS_FACT.INITIAL_INVESTMENT',
  'hseRiskEfficiency': 'COLUMNS.PLAN_VS_FACT.HSE_RISK_EFFICIENCY',
  'likelyScenario': 'COLUMNS.PLAN_VS_FACT.LIKELY_SCENARIO',
  'likelyConsequence': 'COLUMNS.PLAN_VS_FACT.LIKELY_CONSEQUENCE',
  'isCanceled': 'COLUMNS.PLAN_VS_FACT.IS_CANCELED',
  'comment': 'COLUMNS.PLAN_VS_FACT.COMMENT',
  'initiativeOwnerSharedEmail': 'COLUMNS.PLAN_VS_FACT.OWNER',
  'stageStatus': 'COLUMNS.PLAN_VS_FACT.STAGE_STATUS',
  'afeAmount': 'COLUMNS.PLAN_VS_FACT.AFE_AMOUNT_K',
  'costController': 'COLUMNS.PLAN_VS_FACT.COST_CONTROLLER',
  'financeStatus': 'COLUMNS.PLAN_VS_FACT.FINANCE_STATUS',
  'afeStartDate': 'COLUMNS.PLAN_VS_FACT.AFE_START_DATE',
  'afeEndDate': 'COLUMNS.PLAN_VS_FACT.AFE_END_DATE',
  'afeComment': 'COLUMNS.PLAN_VS_FACT.AFE_COMMENTS',
  'areaPriority': 'COLUMNS.PLAN_VS_FACT.AREA_PRIORITY',
  'tcoPriority': 'COLUMNS.PLAN_VS_FACT.TCO_PRIORITY',
  'projectProgress': 'COLUMNS.PLAN_VS_FACT.PROJECT_PROGRESS',
  'projectOwnerEmail': 'COLUMNS.PLAN_VS_FACT.PROJECT_OWNER',
  'fy1': 'COLUMNS.PLAN_VS_FACT.FY1',
  'fy2': 'COLUMNS.PLAN_VS_FACT.FY2',
  'fy3': 'COLUMNS.PLAN_VS_FACT.FY3',
  'approvedBudget': 'COLUMNS.PLAN_VS_FACT.APPROVED_BUDGET_K',
  'isForecastUpdated': 'COLUMNS.PLAN_VS_FACT.IS_FORECAST_UPDATED',
  'isForReview': 'COLUMNS.PLAN_VS_FACT.IS_FOR_REVIEW',
  'initiatorEmail': 'COLUMNS.PLAN_VS_FACT.INITIATOR_EMAIL',

};

export const BREAK_IN_OUT_LABELS: { [key: string]: string } = {
  pk: 'COLUMNS.BREAK_IN_OUT.PK',
  initiativeFk: 'COLUMNS.BREAK_IN_OUT.INITIATIVE_FK',
  area: 'COLUMNS.BREAK_IN_OUT.AREA',
  description: 'COLUMNS.BREAK_IN_OUT.DESCRIPTION',
  justification: 'COLUMNS.BREAK_IN_OUT.JUSTIFICATION',
  originalOutlook: 'COLUMNS.BREAK_IN_OUT.ORIGINAL_OUTLOOK',
  revisedOutlook: 'COLUMNS.BREAK_IN_OUT.REVISED_OUTLOOK',
  delta: 'COLUMNS.BREAK_IN_OUT.BIO_AMOUNT',
  amount: 'COLUMNS.BREAK_IN_OUT.AMOUNT',
  attachments: 'COLUMNS.BREAK_IN_OUT.ATTACHMENTS',
  grandTotalFyOutlook: 'COLUMNS.BREAK_IN_OUT.GRAND_TOTAL_FY_OUTLOOK',
  lastMonthGrandTotalFyOutlook: 'COLUMNS.BREAK_IN_OUT.LAST_MONTH_GRAND_TOTAL_FY_OUTLOOK',
  initiativeOwner: 'COLUMNS.BREAK_IN_OUT.INITIATIVE_OWNER',
  ript: 'COLUMNS.BREAK_IN_OUT.RIPT',
  status: 'COLUMNS.BREAK_IN_OUT.STATUS',
  statusComment: 'COLUMNS.BREAK_IN_OUT.STATUS_COMMENT',
  decision: 'COLUMNS.BREAK_IN_OUT.DECISION',
  decisionComment: 'COLUMNS.BREAK_IN_OUT.DECISION_COMMENT',
  createdOn: 'COLUMNS.BREAK_IN_OUT.CREATED_ON',
  onePInitiative: 'COLUMNS.BREAK_IN_OUT.ONEP_INITIATIVE',
  isCanceled: 'COLUMNS.BREAK_IN_OUT.IS_CANCELED',
  statusModifiedBy: 'COLUMNS.BREAK_IN_OUT.STATUS_MODIFIED_BY',
  statusModifiedOn: 'COLUMNS.BREAK_IN_OUT.STATUS_MODIFIED_ON',
  decisionModifiedBy: 'COLUMNS.BREAK_IN_OUT.DECISION_MODIFIED_BY',
  decisionModifiedOn: 'COLUMNS.BREAK_IN_OUT.DECISION_MODIFIED_ON',
};

export const REPORT_AND_EWR_LABELS: { [key: string]: string } = {
  // Custom derived field
  'type': 'COLUMNS.REPORT_AND_EWR.TYPE',

  // From getAllLinks
  'initiativeId': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_ID',
  'initiativeStage': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_STAGE',
  'initiativeType': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_TYPE',
  'taType': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_TA_TYPE',
  'initiativeBudgetType': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_BUDGET_TYPE',
  'sCcAfe': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_CC_AFE',
  'initiativeId_': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_MEJ_ID',
  'initiativeDescription': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_DESCRIPTION',
  'initiativeAreaType': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_AREA',
  'mciProgram': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_MCI_PROGRAM',
  'year': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_YEAR',
  'multiYear': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_PLANNED_START_DATE',
  'plannedEndDate': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_PLANNED_END_DATE',
  'needByDate': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_NEED_BY_DATE',
  'actualStartDate': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_ACTUAL_START_DATE',
  'actualEndDate': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_ACTUAL_END_DATE',
  'initiativeAfeNumber': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_AFE_NUMBER',
  'originalBudget': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_ORIGINAL_BUDGET_K',
  'revisedBudget': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_REVISED_BUDGET_K',
  'revisedOutlook': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_REVISED_OUTLOOK_K',
  'fyOutlook': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_FY_OUTLOOK_K',
  'actualsYTD': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_ACTUALS_YTD_K',
  'initiativeRipt': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_RIPT',
  'initiativeOwnerSharedEmail': 'COLUMNS.REPORT_AND_EWR.INITIATIVE_OWNER',
  'reportType': 'COLUMNS.REPORT_AND_EWR.REPORT_TYPE',
  'reportFk': 'COLUMNS.REPORT_AND_EWR.REPORT_FK',
  'reportId': 'COLUMNS.REPORT_AND_EWR.REPORT_ID',
  'linkedBy': 'COLUMNS.REPORT_AND_EWR.LINKED_BY',
  'linketAt': 'COLUMNS.REPORT_AND_EWR.LINKED_AT',

  // From external endpoints (common fields)
  'pk': 'COLUMNS.REPORT_AND_EWR.PK',
  'id': 'COLUMNS.REPORT_AND_EWR.ID',
  'description': 'COLUMNS.REPORT_AND_EWR.DESCRIPTION',
  'abc': 'COLUMNS.REPORT_AND_EWR.ABC',
  'sourceState': 'COLUMNS.REPORT_AND_EWR.SOURCE_STATE',
  'sourceStatus': 'COLUMNS.REPORT_AND_EWR.SOURCE_STATUS',
  'sourceCreatedOn': 'COLUMNS.REPORT_AND_EWR.SOURCE_CREATED_ON',
  'sourceLogicalName': 'COLUMNS.REPORT_AND_EWR.SOURCE_LOGICAL_NAME',
  'stage': 'COLUMNS.REPORT_AND_EWR.STAGE',
  'drivingCriteria': 'COLUMNS.REPORT_AND_EWR.DRIVING_CRITERIA',
  'dpi': 'COLUMNS.REPORT_AND_EWR.DPI',
  'hseRiskEfficiency': 'COLUMNS.REPORT_AND_EWR.HSE_RISK_EFFICIENCY',
  'likelyConsequence': 'COLUMNS.REPORT_AND_EWR.LIKELY_CONSEQUENCE',
  'likelyScenario': 'COLUMNS.REPORT_AND_EWR.LIKELY_SCENARIO',
  'ript': 'COLUMNS.REPORT_AND_EWR.RIPT',
  'riptUrl': 'COLUMNS.REPORT_AND_EWR.RIPT_URL',
  'riskManCategory': 'COLUMNS.REPORT_AND_EWR.RISK_MAN_CATEGORY',
  'riskManRiskScore': 'COLUMNS.REPORT_AND_EWR.RISK_MAN_RISK_SCORE',
  'ror': 'COLUMNS.REPORT_AND_EWR.ROR',
  'initialInvestment': 'COLUMNS.REPORT_AND_EWR.INITIAL_INVESTMENT',
  'otpWorkType': 'COLUMNS.REPORT_AND_EWR.OTP_WORK_TYPE',
  'areaType': 'COLUMNS.REPORT_AND_EWR.AREA',
  'externalOwnerSharedEmail': 'COLUMNS.REPORT_AND_EWR.EXTERNAL_OWNER_EMAIL',

  // EWR specific fields
  'afeNumber': 'COLUMNS.REPORT_AND_EWR.AFE_NUMBER',
  'budgetType': 'COLUMNS.REPORT_AND_EWR.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.REPORT_AND_EWR.CC_AFE',
  'costCenter': 'COLUMNS.REPORT_AND_EWR.COST_CENTER',
  'endDate': 'COLUMNS.REPORT_AND_EWR.END_DATE',
  'ewrJoblogId': 'COLUMNS.REPORT_AND_EWR.EWR_JOBLOG_ID',
  'sourceUrl': 'COLUMNS.REPORT_AND_EWR.SOURCE_URL',
  'area': 'COLUMNS.REPORT_AND_EWR.AREA',
  'status': 'COLUMNS.REPORT_AND_EWR.STATUS',
  'sourceId': 'COLUMNS.REPORT_AND_EWR.SOURCE_ID',
};

export const CAPEX_CUTLINE_LABELS: { [key: string]: string } = {
  'complexity': 'COLUMNS.CAPEX_CUTLINE.COMPLEXITY',
  'complexityNumericValue': 'COLUMNS.CAPEX_CUTLINE.COMPLEXITY_VALUE',
  'orderIndex': 'COLUMNS.CAPEX_CUTLINE.ORDER_INDEX',
  'sumOfBudget': 'COLUMNS.CAPEX_CUTLINE.SUM_OF_BUDGET',
  'isIn': 'COLUMNS.CAPEX_CUTLINE.CUTLINE',
  'leftoverAtCut': 'COLUMNS.CAPEX_CUTLINE.LEFTOVER_AT_CUT',
  'pk': 'COLUMNS.CAPEX_CUTLINE.PK',
  'stage': 'COLUMNS.CAPEX_CUTLINE.STAGE',
  'initiativeType': 'COLUMNS.CAPEX_CUTLINE.INITIATIVE_TYPE',
  'taType': 'COLUMNS.CAPEX_CUTLINE.TA_TYPE',
  'budgetType': 'COLUMNS.CAPEX_CUTLINE.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.CAPEX_CUTLINE.CC_AFE',
  'id': 'COLUMNS.CAPEX_CUTLINE.MEJ_ID',
  'description': 'COLUMNS.CAPEX_CUTLINE.DESCRIPTION',
  'areaType': 'COLUMNS.CAPEX_CUTLINE.AREA',
  'mciProgram': 'COLUMNS.CAPEX_CUTLINE.MCI_PROGRAM',
  'year': 'COLUMNS.CAPEX_CUTLINE.YEAR',
  'multiYear': 'COLUMNS.CAPEX_CUTLINE.MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.CAPEX_CUTLINE.PLANNED_START_DATE',
  'plannedEndDate': 'COLUMNS.CAPEX_CUTLINE.PLANNED_END_DATE',
  'needByDate': 'COLUMNS.CAPEX_CUTLINE.NEED_BY_DATE',
  'isServiceRequest': 'COLUMNS.CAPEX_CUTLINE.IS_SERVICE_REQUEST',
  'actualStartDate': 'COLUMNS.CAPEX_CUTLINE.ACTUAL_START_DATE',
  'actualEndDate': 'COLUMNS.CAPEX_CUTLINE.ACTUAL_END_DATE',
  'afeNumber': 'COLUMNS.CAPEX_CUTLINE.AFE_NUMBER',
  'originalBudget': 'COLUMNS.CAPEX_CUTLINE.ORIGINAL_BUDGET_K',
  'revisedBudget': 'COLUMNS.CAPEX_CUTLINE.REVISED_BUDGET_K',
  'revisedOutlook': 'COLUMNS.CAPEX_CUTLINE.REVISED_OUTLOOK_K',
  'fyOutlook': 'COLUMNS.CAPEX_CUTLINE.FY_OUTLOOK_K',
  'actualsYTD': 'COLUMNS.CAPEX_CUTLINE.ACTUALS_YTD_K',
  'opportunityDescription': 'COLUMNS.CAPEX_CUTLINE.OPPORTUNITY_DESCRIPTION',
  'potentialSolution': 'COLUMNS.CAPEX_CUTLINE.POTENTIAL_SOLUTION',
  'riskOrAlternative': 'COLUMNS.CAPEX_CUTLINE.RISK_OR_ALTERNATIVE',
  'riptUrl': 'COLUMNS.CAPEX_CUTLINE.RIPT_URL',
  'abc': 'COLUMNS.CAPEX_CUTLINE.ABC',
  'ript': 'COLUMNS.CAPEX_CUTLINE.RIPT',
  'drivingCriteria': 'COLUMNS.CAPEX_CUTLINE.DRIVING_CRITERIA',
  'riskManRiskScore': 'COLUMNS.CAPEX_CUTLINE.RISK_MANAGEMENT_SCORE',
  'riskManCategory': 'COLUMNS.CAPEX_CUTLINE.RISK_MANAGEMENT_CATEGORY',
  'ror': 'COLUMNS.CAPEX_CUTLINE.ROR',
  'dpi': 'COLUMNS.CAPEX_CUTLINE.DPI',
  'initialInvestment': 'COLUMNS.CAPEX_CUTLINE.INITIAL_INVESTMENT',
  'hseRiskEfficiency': 'COLUMNS.CAPEX_CUTLINE.HSE_RISK_EFFICIENCY',
  'likelyScenario': 'COLUMNS.CAPEX_CUTLINE.LIKELY_SCENARIO',
  'likelyConsequence': 'COLUMNS.CAPEX_CUTLINE.LIKELY_CONSEQUENCE',
  'isCanceled': 'COLUMNS.CAPEX_CUTLINE.IS_CANCELED',
  'comment': 'COLUMNS.CAPEX_CUTLINE.COMMENT',
  'initiativeOwnerSharedEmail': 'COLUMNS.CAPEX_CUTLINE.OWNER',
  'stageStatus': 'COLUMNS.CAPEX_CUTLINE.STAGE_STATUS',
  'actions': 'COLUMNS.CAPEX_CUTLINE.ACTIONS',
  'afeAmount': 'COLUMNS.CAPEX_CUTLINE.AFE_AMOUNT_K',
  'costController': 'COLUMNS.CAPEX_CUTLINE.COST_CONTROLLER',
  'financeStatus': 'COLUMNS.CAPEX_CUTLINE.FINANCE_STATUS',
  'afeStartDate': 'COLUMNS.CAPEX_CUTLINE.AFE_START_DATE',
  'afeEndDate': 'COLUMNS.CAPEX_CUTLINE.AFE_END_DATE',
  'afeComment': 'COLUMNS.CAPEX_CUTLINE.AFE_COMMENTS',
  'areaPriority': 'COLUMNS.CAPEX_CUTLINE.AREA_PRIORITY',
  'tcoPriority': 'COLUMNS.CAPEX_CUTLINE.TCO_PRIORITY',
  'projectProgress': 'COLUMNS.CAPEX_CUTLINE.PROJECT_PROGRESS',
  'createdOn': 'COLUMNS.CAPEX_CUTLINE.CREATED_ON',
  'createdBy': 'COLUMNS.CAPEX_CUTLINE.CREATED_BY',
  'approvedBudget': 'COLUMNS.CAPEX_CUTLINE.APPROVED_BUDGET_K',
  'coordinatorName': 'COLUMNS.CAPEX_CUTLINE.COORDINATOR_NAME',
  'coordinatorEmail': 'COLUMNS.CAPEX_CUTLINE.COORDINATOR_EMAIL',
  'fy1': 'COLUMNS.CAPEX_CUTLINE.FY1',
  'fy2': 'COLUMNS.CAPEX_CUTLINE.FY2',
  'fy3': 'COLUMNS.CAPEX_CUTLINE.FY3',
  'isForecastUpdated': 'COLUMNS.CAPEX_CUTLINE.IS_FORECAST_UPDATED',
  'isForReview': 'COLUMNS.CAPEX_CUTLINE.IS_FOR_REVIEW',
  'initiatorEmail': 'COLUMNS.CAPEX_CUTLINE.INITIATOR_EMAIL',
  'currentFyGrandTotal': 'COLUMNS.CAPEX_CUTLINE.CURRENT_FY_GRAND_TOTAL',
  'lastFyGrandTotal': 'COLUMNS.CAPEX_CUTLINE.LAST_FY_GRAND_TOTAL'
};
export const CAPEX_PRIORITIZATION_LABELS: { [key: string]: string } = {
  'fy1': 'COLUMNS.CAPEX_PRIORITIZATION.FY1',
  'fy2': 'COLUMNS.CAPEX_PRIORITIZATION.FY2',
  'fy3': 'COLUMNS.CAPEX_PRIORITIZATION.FY3',
  'complexity': 'COLUMNS.CAPEX_PRIORITIZATION.COMPLEXITY',
  'complexityNumericValue': 'COLUMNS.CAPEX_PRIORITIZATION.COMPLEXITY_VALUE',
  'orderIndex': 'COLUMNS.CAPEX_PRIORITIZATION.ORDER_INDEX',
  'sumOfBudget': 'COLUMNS.CAPEX_PRIORITIZATION.SUM_OF_BUDGET',
  'isIn': 'COLUMNS.CAPEX_PRIORITIZATION.CUTLINE',
  'leftoverAtCut': 'COLUMNS.CAPEX_PRIORITIZATION.LEFTOVER_AT_CUT',
  'pk': 'COLUMNS.CAPEX_PRIORITIZATION.PK',
  'stage': 'COLUMNS.CAPEX_PRIORITIZATION.STAGE',
  'initiativeType': 'COLUMNS.CAPEX_PRIORITIZATION.INITIATIVE_TYPE',
  'taType': 'COLUMNS.CAPEX_PRIORITIZATION.TA_TYPE',
  'budgetType': 'COLUMNS.CAPEX_PRIORITIZATION.BUDGET_TYPE',
  'ccAfe': 'COLUMNS.CAPEX_PRIORITIZATION.CC_AFE',
  'id': 'COLUMNS.CAPEX_PRIORITIZATION.MEJ_ID',
  'description': 'COLUMNS.CAPEX_PRIORITIZATION.DESCRIPTION',
  'areaType': 'COLUMNS.CAPEX_PRIORITIZATION.AREA',
  'isServiceRequest': 'COLUMNS.CAPEX_PRIORITIZATION.IS_SERVICE_REQUEST',
  'mciProgram': 'COLUMNS.CAPEX_PRIORITIZATION.MCI_PROGRAM',
  'year': 'COLUMNS.CAPEX_PRIORITIZATION.YEAR',
  'multiYear': 'COLUMNS.CAPEX_PRIORITIZATION.MULTI_YEAR',
  'plannedStartDate': 'COLUMNS.CAPEX_PRIORITIZATION.PLANNED_START_DATE',
  'plannedEndDate': 'COLUMNS.CAPEX_PRIORITIZATION.PLANNED_END_DATE',
  'needByDate': 'COLUMNS.CAPEX_PRIORITIZATION.NEED_BY_DATE',
  'actualStartDate': 'COLUMNS.CAPEX_PRIORITIZATION.ACTUAL_START_DATE',
  'actualEndDate': 'COLUMNS.CAPEX_PRIORITIZATION.ACTUAL_END_DATE',
  'afeNumber': 'COLUMNS.CAPEX_PRIORITIZATION.AFE_NUMBER',
  'originalBudget': 'COLUMNS.CAPEX_PRIORITIZATION.ORIGINAL_BUDGET_K',
  'revisedBudget': 'COLUMNS.CAPEX_PRIORITIZATION.REVISED_BUDGET_K',
  'revisedOutlook': 'COLUMNS.CAPEX_PRIORITIZATION.REVISED_OUTLOOK_K',
  'fyOutlook': 'COLUMNS.CAPEX_PRIORITIZATION.FY_OUTLOOK_K',
  'actualsYTD': 'COLUMNS.CAPEX_PRIORITIZATION.ACTUALS_YTD_K',
  'opportunityDescription': 'COLUMNS.CAPEX_PRIORITIZATION.OPPORTUNITY_DESCRIPTION',
  'potentialSolution': 'COLUMNS.CAPEX_PRIORITIZATION.POTENTIAL_SOLUTION',
  'riskOrAlternative': 'COLUMNS.CAPEX_PRIORITIZATION.RISK_OR_ALTERNATIVE',
  'riptUrl': 'COLUMNS.CAPEX_PRIORITIZATION.RIPT_URL',
  'abc': 'COLUMNS.CAPEX_PRIORITIZATION.ABC',
  'ript': 'COLUMNS.CAPEX_PRIORITIZATION.RIPT',
  'drivingCriteria': 'COLUMNS.CAPEX_PRIORITIZATION.DRIVING_CRITERIA',
  'riskManRiskScore': 'COLUMNS.CAPEX_PRIORITIZATION.RISK_MANAGEMENT_SCORE',
  'riskManCategory': 'COLUMNS.CAPEX_PRIORITIZATION.RISK_MANAGEMENT_CATEGORY',
  'ror': 'COLUMNS.CAPEX_PRIORITIZATION.ROR',
  'dpi': 'COLUMNS.CAPEX_PRIORITIZATION.DPI',
  'initialInvestment': 'COLUMNS.CAPEX_PRIORITIZATION.INITIAL_INVESTMENT',
  'hseRiskEfficiency': 'COLUMNS.CAPEX_PRIORITIZATION.HSE_RISK_EFFICIENCY',
  'likelyScenario': 'COLUMNS.CAPEX_PRIORITIZATION.LIKELY_SCENARIO',
  'likelyConsequence': 'COLUMNS.CAPEX_PRIORITIZATION.LIKELY_CONSEQUENCE',
  'isCanceled': 'COLUMNS.CAPEX_PRIORITIZATION.IS_CANCELED',
  'comment': 'COLUMNS.CAPEX_PRIORITIZATION.COMMENT',
  'initiativeOwnerSharedEmail': 'COLUMNS.CAPEX_PRIORITIZATION.OWNER',
  'stageStatus': 'COLUMNS.CAPEX_PRIORITIZATION.STAGE_STATUS',
  'actions': 'COLUMNS.CAPEX_PRIORITIZATION.ACTIONS',
  'afeAmount': 'COLUMNS.CAPEX_PRIORITIZATION.AFE_AMOUNT_K',
  'costController': 'COLUMNS.CAPEX_PRIORITIZATION.COST_CONTROLLER',
  'financeStatus': 'COLUMNS.CAPEX_PRIORITIZATION.FINANCE_STATUS',
  'afeStartDate': 'COLUMNS.CAPEX_PRIORITIZATION.AFE_START_DATE',
  'afeEndDate': 'COLUMNS.CAPEX_PRIORITIZATION.AFE_END_DATE',
  'afeComment': 'COLUMNS.CAPEX_PRIORITIZATION.AFE_COMMENTS',
  'areaPriority': 'COLUMNS.CAPEX_PRIORITIZATION.AREA_PRIORITY',
  'tcoPriority': 'COLUMNS.CAPEX_PRIORITIZATION.TCO_PRIORITY',
  'projectProgress': 'COLUMNS.CAPEX_PRIORITIZATION.PROJECT_PROGRESS',
  'createdOn': 'COLUMNS.CAPEX_PRIORITIZATION.CREATED_ON',
  'createdBy': 'COLUMNS.CAPEX_PRIORITIZATION.CREATED_BY',
  'approvedBudget': 'COLUMNS.CAPEX_PRIORITIZATION.APPROVED_BUDGET_K',
  'coordinatorName': 'COLUMNS.CAPEX_PRIORITIZATION.COORDINATOR_NAME',
  'coordinatorEmail': 'COLUMNS.CAPEX_PRIORITIZATION.COORDINATOR_EMAIL',
  'isForecastUpdated': 'COLUMNS.CAPEX_PRIORITIZATION.IS_FORECAST_UPDATED',
  'isForReview': 'COLUMNS.CAPEX_PRIORITIZATION.IS_FOR_REVIEW',
  'initiatorEmail': 'COLUMNS.CAPEX_PRIORITIZATION.INITIATOR_EMAIL',
  'currentFyGrandTotal': 'COLUMNS.CAPEX_PRIORITIZATION.CURRENT_FY_GRAND_TOTAL',
  'lastFyGrandTotal': 'COLUMNS.CAPEX_PRIORITIZATION.LAST_FY_GRAND_TOTAL'
};
